module.exports = __webpack_public_path__ + "static/media/pg.64780991.svg";